module.exports = __webpack_public_path__ + "img/calender.ab07a9c7.svg";